import { render, staticRenderFns } from "./SectionSplit.vue?vue&type=template&id=03eb762c"
import script from "./SectionSplit.vue?vue&type=script&lang=js"
export * from "./SectionSplit.vue?vue&type=script&lang=js"
import style0 from "./SectionSplit.vue?vue&type=style&index=0&id=03eb762c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports